module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(!_vm.loading) ? _c('img', {
    staticClass: "lightbox__image",
    style: (_vm.style),
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "lightbox__loading"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin fa-3x fa-fw"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a9a6f54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lightbox/LightboxImage.vue
// module id = 436
// module chunks = 1